import { FilingStateTypes } from "types/Models/task";

export const categorizeFilingState = (stateType: FilingStateTypes) => {
  switch (stateType) {
    case "PAYMENT":
      return "PAYMENT";

    case "FORM_FILING":
    case "W_SERIES":
    case "UPLOAD_DOCUMENTS":
    case "TASK_DEFINING":
      return "FORM_FILING";

    case "REVIEW":
    case "FILING_IN_PROGRESS":
      return "FILING_IN_PROGRESS";

    case "SUBMITTED":
      return "SUBMITTED";

    case "TASK_AMENDMENT":
    case "TASK_AMENDMENT_DOCUMENTS":
      return "TASK_AMENDMENT";

    case "TASK_AMENDMENT_COMPLETED":
      return "TASK_AMENDMENT_COMPLETED";

    default:
      return stateType;
  }
};
